module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/suns_sns_03-5f1313ad117553adcbe2ab1f62387975.jpg";